(() => {
  'use strict';
  if (window.aceHeaderSelectionReady) return;
  window.aceHeaderSelectionReady = true;
  const choices = {
    AceChooseCases: '#AcePreferenceFinder .ace-cases__heading h2',
    AceChooseImage: '#AcePreferenceFinder .ace-preferences__heading h2',
    AceChooseSpaces: '.ace-category-explorer__space-heading',
    AceChooseKinds: '.ace-category-explorer__classification-heading'
  };
  function move(hash, focus) {
    const target = document.querySelector(choices[hash] || 'html[data-no-ace-choice]');
    if (!target) return false;
    const band = document.querySelector('.ace-member-announcement-section');
    const header = document.querySelector('.section-header');
    const offset = Math.max(band?.getBoundingClientRect().bottom || 0, header?.classList.contains('shopify-section-header-sticky') ? header.getBoundingClientRect().bottom : 0, 0) + 12;
    window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top + scrollY - offset),behavior:'instant'});
    if (focus) {
      const temporary = !target.hasAttribute('tabindex');
      if (temporary) target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
      if (temporary) target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});
    }
    return true;
  }
  document.addEventListener('click',event=>{
    if (event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const link=event.target.closest('[data-ace-header-choice]');
    if (!link) return;
    const url=new URL(link.href,location.href),key=url.hash.slice(1);
    if (url.origin!==location.origin || !choices[key] || !document.querySelector(choices[key])) return;
    event.preventDefault();
    const drawer=link.closest('header-drawer')?.querySelector('details[open]');
    drawer?.querySelector('summary')?.click();
    if (location.hash!==url.hash) history.pushState(history.state,'',url.hash);
    move(key,true);
    requestAnimationFrame(()=>move(key,false));
  });
  const restore=()=>move(location.hash.slice(1),false);
  window.addEventListener('hashchange',restore);
  window.addEventListener('popstate',restore);
  window.addEventListener('load',restore);
  restore();
})();
